import { LanguageLevelEnum } from '../../enums';
import { UsersInterface } from './users.interface';

export class UsersLanguagesInterface {
  key?: string;
  languageLevel?: LanguageLevelEnum;
  userId?: string;
  user?: UsersInterface;
}
